export const AGENTNET_TYPES_RESET_STATE = 'AGENTNET_TYPES_RESET_STATE';
export const AGENTNET_TYPES_CURRENT_ITEM = 'AGENTNET_TYPES_CURRENT_ITEM';

export const AGENTNET_TYPES_REQUEST_LOADING = 'AGENTNET_TYPES_REQUEST_LOADING';
export const AGENTNET_TYPES_REQUEST_SUCCESS = 'AGENTNET_TYPES_REQUEST_SUCCESS';
export const AGENTNET_TYPES_REQUEST_FAILED = 'AGENTNET_TYPES_REQUEST_FAILED';

export const AGENTNET_TYPES_CURRENT_ACTION = 'AGENTNET_TYPES_CURRENT_ACTION';
export const AGENTNET_TYPES_RESET_ACTION = 'AGENTNET_TYPES_RESET_ACTION';